import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeWeblinkTypeCreate,
  detail: routeWeblinkTypeDetail,
  home: routeWeblinkTypeSettingsHome,
  root: routeWeblinkTypeSettingsRoot,
} = createDoctypeRoutes({
  createName: 'new-weblink-type',
  createPath: 'new-weblink-type',
  detailName: 'weblinkTypeDetail',
  doctype: DOCTYPES.TW_WEBLINK_TYPE,
  homeName: 'weblink-type',
  path: 'weblink-type',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/twWeblinkType/AddTwWeblinkType.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/twWeblinkType/ViewTwWeblinkType.vue'),
    list: async () => await import('@/components/viewsExternal/settings/brm/ViewBRMSettings.vue'),
  },
})

export {
  routeWeblinkTypeCreate,
  routeWeblinkTypeDetail,
  routeWeblinkTypeSettingsHome,
  routeWeblinkTypeSettingsRoot,
}
